import { get, post } from "Service";

const initiatePayment = (payload: any) => {
  const request = {
    subUrl: `initiate`,
    data: payload,
    isPayment: true,
  };
  return post(request);
};

const getAdminPaymentHistory = async () => {
  try {
    const request = {
      subUrl: "Payments/admin",
      isAuth: false,
    };
    return await get(request);
  } catch (error) {
    console.error("Error fetching order history:", error);
    throw error;
  }
}

const getUserPaymentHistory = async () => {
  try {
    const request = {
      subUrl: "Payments/user-payments",
      isAuth: false,
    };
    return await get(request);
  } catch (error) {
    console.error("Error fetching order history:", error);
    throw error;
  }
}

const refundPayment = (payload: any) => {
  const request = {
    subUrl: `Payments/refund`,
    data: payload,
    isAuth: false,
  };
  return post(request);
};

const getRewardHistory = (userId: number) => {
  const request = {
    subUrl: `Payments/Rewards/user-history/${userId}`,
    data: {},
    isAuth: false,
  };
  return get(request);
};


/**
 * GET: Fetch cases assigned to a specific professional that are finished/completed 
 * but do not yet have an associated payout record.
 * @param {string | number} profId - The Unique ID of the Professional.
 */
export const getProfessionalUnpaidCases = (profId: string | number) => {
    const request = {
        subUrl: `Payments/cases-eligible-for-payout/${profId}`,
        isAuth: false,
    };
    return get(request); // Assuming you have a get() helper similar to put()
};

/**
 * POST: Allows an Admin to submit a batch of payment amounts for various cases.
 * These records are saved in the 'Payouts' table with a 'PendingApproval' status.
 * @param {Object} payload - { professionalId: number, entries: [{ caseId: number, amount: number }] }
 */
export const submitBulkProfessionalPayments = (payload: any) => {
    const request = {
        subUrl: "Payments/request-payouts",
        isAuth: false,
        data: payload,
    };
    return post(request);
};

/**
 * GET: Fetches a list of all payout records currently waiting for SuperAdmin approval.
 * Used to populate the SuperAdminApproval queue table.
 */
export const getPendingPayouts = () => {
    return get({ subUrl: "Payments/pending-payouts", isAuth: false });
};

/**
 * POST: Finalizes payouts by changing status from 'PendingApproval' to 'Completed'.
 * This updates both the Payout record and the corresponding Case payment status.
 * Supports both single approval (array of 1 ID) and bulk approval (array of many IDs).
 * @param {number[]} payoutIds - An array of Payout Primary Keys (e.g., [101, 102, 105]).
 */
export const approvePayoutsBulk = (payoutIds: number[]) => {
    return post({ 
        subUrl: `Payments/approve-payouts-bulk`, 
        isAuth: false,
        data: { payoutIds }
    });
};

export const downloadCompletedPayouts = () => {
    const request = {
        subUrl: `Payments/export-completed-payouts`,
        isAuth: false,
        excel: true,
    };
    return get(request);
};

/**
 * GET: Fetches a list of all completed payout records.
 * Used to populate the CompletedPayouts table.
 */
export const getCompletedPayouts = () => {
    return get({ subUrl: "Payments/completed-payouts", isAuth: false });
};

/**
 * POST: Generates a payment link for a specific case.
 * @param {string | number} profId - The Unique ID of the Professional.
 * @param {Object} payload - { caseId: number, amount: number }
 */
export const generatePaymentLinkForCase = (payload: any) => {
    const request = {
        subUrl: `Payments/sent-payment-link-for-case`,
        isAuth: false,
        data: payload,
    };
    return post(request);
};

const PaymentApi = {
  initiatePayment,
  getAdminPaymentHistory,
  getUserPaymentHistory,
  refundPayment,
  getRewardHistory,
  getProfessionalUnpaidCases,
  submitBulkProfessionalPayments,
  getPendingPayouts,
  approvePayoutsBulk,
  getCompletedPayouts,
  downloadCompletedPayouts,
  generatePaymentLinkForCase,
};

export default PaymentApi;
